module.exports = __webpack_public_path__ + "img/icon-update.77ebe28a.png";